// extracted by mini-css-extract-plugin
module.exports = {"advert":"_2T9LXz7","hide":"_2IMaDeE"};